// Tiny inline SVG icons (placeholder art, no icon font or network fetch).
export type IconName =
  | "lock"
  | "eye"
  | "book"
  | "gear"
  | "bag"
  | "crown"
  | "door"
  | "users"
  | "refresh"
  | "close"
  | "plus"
  | "gift"
  | "sliders"
  | "logout"
  | "back"
  | "shop"
  | "coin"
  | "heart"
  | "swirl"
  | "flag"
  | "search"
  | "chest"
  | "bolt"
  | "chat"
  | "smile"
  | "cigar"
  | "slots"
  | "arrowRight"
  | "arrowLeft"
  | "chair"
  | "wizard"
  | "moneyBag";

const PATHS: Record<IconName, string> = {
  lock: "M7 10V7a5 5 0 0 1 10 0v3h1a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h1zm2 0h6V7a3 3 0 0 0-6 0v3z",
  eye: "M12 5c5 0 9 4.5 10 7-1 2.5-5 7-10 7S3 14.5 2 12c1-2.5 5-7 10-7zm0 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4z",
  book: "M4 4.5A2.5 2.5 0 0 1 6.5 2H20v17H6.5a1.5 1.5 0 0 0 0 3H20v-1h0v1H6.5A3.5 3.5 0 0 1 3 18.5v-14A.5.5 0 0 1 4 4.5zM12 6l1.2 2.6L16 9l-2 2 .5 2.8L12 12.5 9.5 13.8 10 11 8 9l2.8-.4z",
  gear: "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm8.6 5.4l1.9 1.5-2 3.4-2.3-.9a8 8 0 0 1-2 1.2L16 21h-4l-.4-2.4a8 8 0 0 1-2-1.2l-2.3.9-2-3.4 1.9-1.5a8 8 0 0 1 0-2.8L5.3 9.1l2-3.4 2.3.9a8 8 0 0 1 2-1.2L12 3h4l.4 2.4a8 8 0 0 1 2 1.2l2.3-.9 2 3.4-1.9 1.5a8 8 0 0 1 0 2.8z",
  bag: "M6 7h12l1.5 14h-15zM9 7a3 3 0 0 1 6 0h-2a1 1 0 0 0-2 0z",
  crown: "M3 7l4.5 4L12 4l4.5 7L21 7l-2 12H5z",
  door: "M5 3h10v18H5zm10 2h4v16h-4v-2h2V7h-2zm-4 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
  users: "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm-7 9a7 7 0 0 1 14 0v1H2zm15-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm1 2a6 6 0 0 1 4 6v2h-4v-2a8 8 0 0 0-2.5-5.8A6 6 0 0 1 18 13z",
  refresh: "M12 4a8 8 0 0 1 7.4 5H22l-3.5 4L15 9h2.2A6 6 0 1 0 18 14h2.1A8 8 0 1 1 12 4z",
  close: "M6.4 5L12 10.6 17.6 5 19 6.4 13.4 12l5.6 5.6-1.4 1.4-5.6-5.6L6.4 19 5 17.6l5.6-5.6L5 6.4z",
  plus: "M11 5h2v6h6v2h-6v6h-2v-6H5v-2h6z",
  gift: "M3 8h18v4H3zm1 5h7v8H4zm9 0h7v8h-7zM12 8C10 4 7 4 7 6s3 2 5 2zm0 0c2-4 5-4 5-2s-3 2-5 2z",
  logout: "M4 3h9v2H6v14h7v2H4zm12 4l5 5-5 5-1.4-1.4 2.6-2.6H9v-2h8.2l-2.6-2.6z",
  back: "M11 4L3 12l8 8 1.4-1.4L6.8 13H21v-2H6.8l5.6-5.6z",
  shop: "M4 4h16l1 5a3 3 0 0 1-5 2 3 3 0 0 1-4 0 3 3 0 0 1-4 0 3 3 0 0 1-5-2zm1 9h2v6h10v-6h2v8H5z",
  coin: "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20zm1 4h-2v1.1A3 3 0 0 0 11 13h2a1 1 0 0 1 0 2h-3v2h1v1h2v-1.1A3 3 0 0 0 13 11h-2a1 1 0 0 1 0-2h3V7h-1z",
  heart: "M12 21l-1.5-1.3C5 15 2 12 2 8.5A5 5 0 0 1 7 3.5c2 0 3.6 1 5 2.7 1.4-1.7 3-2.7 5-2.7a5 5 0 0 1 5 5c0 3.5-3 6.5-8.5 11.2z",
  swirl: "M12 3a9 9 0 1 1-9 9h2a7 7 0 1 0 7-7 5 5 0 0 0 0 10 3 3 0 0 0 0-6 1 1 0 0 0 0 2v2a3 3 0 0 1 0-6 5 5 0 0 1 0 10 7 7 0 0 1 0-14z",
  flag: "M5 3h2v18H5zm3 1h11l-2 4 2 4H8z",
  search: "M10 3a7 7 0 0 1 5.6 11.2l5.1 5.1-1.4 1.4-5.1-5.1A7 7 0 1 1 10 3zm0 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10z",
  bolt: "M13 2L4 14h6l-1 8 9-12h-6z",
  chat: "M4 4h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H9l-5 4v-4H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm3 5v2h10V9zm0 4v2h7v-2z",
  // Just eyes and a grin: the round button it sits in is the face.
  smile: "M8 6.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM5 13.5h14a7 7 0 0 1-14 0z",
  cigar: "M2 11h15v4H2zm16 0h2v4h-2zm3 0h1v4h-1zM15 4c2 1 2 3 0 4 3 0 3-3 1-5zm3 1c1 1 1 2 0 3 2 0 2-2 1-3z",
  slots: "M5 2h12a2 2 0 0 1 2 2v16H3V4a2 2 0 0 1 2-2zm1 4v6h10V6zm1 1h2v4H7zm3 0h2v4h-2zm3 0h2v4h-2zM6 15v3h10v-3zM20 6h1v7h-1a1 1 0 0 1-1-1V8zm.5-3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
  arrowRight: "M13 4l8 8-8 8-1.4-1.4 5.6-5.6H3v-2h14.2l-5.6-5.6z",
  arrowLeft: "M11 4L3 12l8 8 1.4-1.4L6.8 13H21v-2H6.8l5.6-5.6z",
  chair: "M6 2h12v10H6zm2 2v6h8V4zM4 13h16v3h-2v6h-2v-6H8v6H6v-6H4z",
  // A smiling face under a pointy wizard hat (star, eyes and grin are cut out).
  wizard:
    "M13.5 1L18 10h3.5v2h-19v-2H6l4.5-5.5zM12 6.2a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8zM12 12.5a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm-2 2.6a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-3.6 3.5a1.6 1.6 0 0 0 3.2 0z",
  // A tied sack with a coin on it (the coin's ring is cut out).
  moneyBag:
    "M7.5 2h9l-2.2 3.6h-4.6zM9.6 6.6h4.8v1.6H9.6zM10 9.2h4c3.6 2 6.6 5.4 6.6 8.8a3.9 3.9 0 0 1-3.9 3.9H7.3A3.9 3.9 0 0 1 3.4 18c0-3.4 3-6.8 6.6-8.8zM12 12.2a3.3 3.3 0 1 0 0 6.6 3.3 3.3 0 0 0 0-6.6zm0 1.7a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2z",
  chest: "M3 9a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v1H3zm0 3h8v2h2v-2h8v8H3z",
  sliders: "M3 6h9.2a3 3 0 0 1 5.6 0H21v2h-3.2a3 3 0 0 1-5.6 0H3zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM3 16h3.2a3 3 0 0 1 5.6 0H21v2h-9.2a3 3 0 0 1-5.6 0H3zm6 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
};

export function Icon({ name, size = 20, title }: { name: IconName; size?: number; title?: string }) {
  return (
    <svg
      className="icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      {title && <title>{title}</title>}
      <path d={PATHS[name]} fillRule="evenodd" />
    </svg>
  );
}
